import { Alert } from '../common'
import { moderationStateBannerView } from './moderationStateBannerModel'
import { useModerationStatus } from './useModerationStatus'

// ModerationStateBanner says whether moderation applies to the brand now:
// off everywhere, off for this brand, observe-only, or on. Loading and
// errors render nothing: the page works without it. context is 'rules' or
// 'queue'.
export default function ModerationStateBanner({ orgSlug, context }) {
  const { data } = useModerationStatus(orgSlug)
  const view = moderationStateBannerView(data, context)
  if (!view) return null
  return <Alert variant={view.variant}>{view.text}</Alert>
}
